import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const getRtkErrorMessage = (
  error: FetchBaseQueryError | SerializedError
): string => {
  if ('message' in error && error.message) return error.message;
  if ('error' in error && error.error) return error.error;
  if ('data' in error && error.data != null) {
    if (typeof error.data === 'string') return error.data;
    if (typeof error.data === 'object') {
      if ('message' in error.data && typeof error.data.message === 'string') {
        return error.data.message;
      }
    }
  }
  return 'Unknown error';
};
